// @ts-nocheck: converted from JS

import StudyGroupSetup from '@/components/Studies/Settings/Steps/Groups/StudyGroupSetup';
import { generateGroupBulkUpdateOperations } from '@/components/Studies/StudyGroups/Groups/Groups.utils';
import { errorToast, successToast } from '@/helpers';
import { _isNotEmpty } from '@/littledash';
import { useRequest } from '@/support/Hooks/request';
import { api as apiRoute } from '@/support/route';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '@/components/Loading';
import { useFetchCollection } from '@/support/Hooks/fetch';
import ApiErrorBanner from '@/components/ApiErrorBanner';

const GroupsTable = ({ groups = [], reloadGroups, canEdit = true }) => {
  const { id: studyId } = useParams();

  const [groupsState, setGroupsState] = useState([...groups]);
  const [isUpdating, setIsUpdating] = useState(false);

  const { sendRequest: bulkUpdateGroups } = useRequest({
    route: apiRoute('studies.groups.bulk', { studyId }),
    method: 'post',
  });

  useEffect(() => {
    setGroupsState(groups);
  }, [groups]);

  const handleSave = async (updatedGroups) => {
    const operations = generateGroupBulkUpdateOperations(groupsState, updatedGroups);
    if (_isNotEmpty(operations)) {
      setIsUpdating(true);
      try {
        const updateSuccessful = await bulkUpdateGroups({ operations });
        if (updateSuccessful) {
          successToast('Groups updated successfully');
          setGroupsState(updatedGroups);
          await reloadGroups();
        } else {
          errorToast('Error updating groups');
        }
      } finally {
        setIsUpdating(false);
      }
    }
  };

  const {
    collection: savedGroupData,
    collectionLoading: savedGroupDataLoading,
    collectionError: savedGroupDataError,
  } = useFetchCollection<DisplayedGroupMetadata>({
    collectionType: 'teamStudiesGroups',
  });

  if (savedGroupDataLoading) {
    return (
      <div className="pa4">
        <Loading />
      </div>
    );
  }
  return (
    <div className={`${_isNotEmpty(groups) ? '' : 'pa4'}`}>
      {savedGroupDataError && (
        <ApiErrorBanner
          className="mb4"
          title={'There was a problem fetching treatment group metadata'}
          text={
            'An error has occurred when submitting your request, please try again later. If this keeps occurring please contact support.'
          }
          error={savedGroupDataError}
        />
      )}
      <StudyGroupSetup
        groups={groupsState}
        onUpdateGroupData={handleSave}
        canEdit={canEdit}
        savedGroupData={savedGroupData}
        isUpdating={isUpdating}
      />
    </div>
  );
};

export default GroupsTable;
